var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxDermatology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b29675aa-5001-4bfc-8fa2-1dc6ae728b5b",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "e39d7500-11fb-4dd0-923f-2864dd1c72f0",
    "data-name": "Path 86",
    d: "M14.829,16.336,13.464,6.9a.8.8,0,0,0-.793-.687h-.7V5.77a.8.8,0,0,0-.8-.8h-.46V4.553a.748.748,0,0,0-.027-.2h2.557a.8.8,0,0,0,0-1.6H8.649a.8.8,0,0,0,0,1.6h.486a.838.838,0,0,0-.027.2v.416H8.649a.8.8,0,0,0-.8.8v.437H7.327a.8.8,0,0,0-.793.687L5.172,16.336a.8.8,0,0,0,.681.9.829.829,0,0,0,.111.008h8.07a.8.8,0,0,0,.8-.8.768.768,0,0,0-.009-.117m-7.936-.684,1.13-7.838H11.98l1.13,7.838Z",
    style: {
      fill: "#005a7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bdcdb202-46a1-4890-9da8-5017c710764a",
    "data-name": "Path 87",
    d: "M8.52,12.975a1.481,1.481,0,0,0,2.961,0C11.481,12.157,10,9.8,10,9.8s-1.48,2.361-1.48,3.179",
    style: {
      fill: "#005a7d"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxDermatology);
export default __webpack_public_path__ + "static/media/bxDermatology.2aff6beebc97d318ecccf5bc2c072197.svg";
export { ForwardRef as ReactComponent };